// Configuration de l'API
// Détection automatique de l'environnement (mobile vs web)
const isMobile =
  typeof window !== 'undefined' &&
  (window.Capacitor?.isNativePlatform?.() ||
    window.Capacitor?.getPlatform?.() === 'android' ||
    window.Capacitor?.getPlatform?.() === 'ios' ||
    window.location.protocol === 'capacitor:' ||
    window.location.protocol === 'ionic:')

// URLs de production
const PRODUCTION_API_URL_HTTPS = 'https://gpao.inveep.com'
const PRODUCTION_API_URL_HTTP = 'https://gpao.inveep.com'

// URL de base pour les reçus (toujours utiliser le domaine de production)
export const RECU_BASE_URL = 'https://gpao.inveep.com'

// URL locale pour le développement
const LOCAL_API_URL = 'http://localhost:5001'

// Détection du mode développement local
const isLocalDev = typeof window !== 'undefined' && 
  window.location.hostname === 'localhost' && 
  !isMobile

// Debug: afficher l'environnement détecté
if (typeof window !== 'undefined') {
  console.log('🔍 API Config - isMobile:', isMobile)
  console.log('🔍 API Config - isLocalDev:', isLocalDev)
  console.log('🔍 API Config - Capacitor:', window.Capacitor)
  console.log('🔍 API Config - Protocol:', window.location?.protocol)
  console.log('🔍 API Config - Hostname:', window.location?.hostname)
}

// Déterminer l'URL de l'API selon le contexte
const getApiUrl = () => {
  // En développement local (localhost), utiliser le backend local
  if (isLocalDev) {
    console.log('🏠 Mode développement local détecté - utilisation du backend local')
    return LOCAL_API_URL
  }
  
  // En mobile natif, utiliser HTTP direct vers le serveur de production
  if (isMobile) {
    return PRODUCTION_API_URL_HTTP
  }
  
  // En web production avec HTTPS ou domaine de production, utiliser HTTPS
  if (typeof window !== 'undefined') {
    const isHttps = window.location.protocol === 'https:'
    const isProductionDomain = window.location.hostname === 'gpao.inveep.com'
    
    // IMPORTANT: Si on est en HTTPS, on DOIT utiliser HTTPS pour l'API (Mixed Content)
    if (isHttps || isProductionDomain) {
      console.log('🔒 Mode HTTPS/Production détecté - utilisation de HTTPS pour l\'API')
      return PRODUCTION_API_URL_HTTPS
    }
    
    // Si on accède via IP directe en HTTP
    if (window.location.hostname === '62.171.145.19') {
      return PRODUCTION_API_URL_HTTP
    }
  }
  
  return PRODUCTION_API_URL_HTTP
}

// Calculer l'URL de base
export const API_BASE_URL = getApiUrl()

console.log('🌐 API Base URL:', API_BASE_URL)

// Helper function pour construire les URLs API complètes
export const buildApiUrl = (path) => {
  if (path.startsWith('http')) {
    return path
  }
  if (path.startsWith('/api')) {
    return `${API_BASE_URL}${path}`
  }
  if (path.startsWith('/')) {
    return `${API_BASE_URL}${path}`
  }
  return `${API_BASE_URL}/${path}`
}

// Override global fetch pour les URLs /api
const originalFetch = window.fetch
window.fetch = function (url, options) {
  // Si l'URL commence par /api, on la transforme en URL complète
  if (typeof url === 'string' && url.startsWith('/api')) {
    const fullUrl = buildApiUrl(url)
    console.log('🔄 Fetch intercepted:', url, '->', fullUrl)
    return originalFetch(fullUrl, options)
  }
  return originalFetch(url, options)
}

export default {
  baseURL: API_BASE_URL,
  getApiUrl: buildApiUrl,
}
